
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Team = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M12.5,11.1a4.2,4.2,0,0,0,4.2-4.2,4.2,4.2,0,0,0-8.4,0A4.2,4.2,0,0,0,12.5,11.1Zm0-6.8A2.7,2.7,0,1,1,9.8,6.9,2.7,2.7,0,0,1,12.5,4.3Z"></path>
            <path d="M5,12.5A2.8,2.8,0,0,0,7.8,9.7,2.9,2.9,0,0,0,5,6.9,2.9,2.9,0,0,0,2.2,9.7,2.8,2.8,0,0,0,5,12.5ZM5,8.4A1.3,1.3,0,1,1,3.7,9.7,1.3,1.3,0,0,1,5,8.4Z"></path>
            <path d="M23.8,20.5V15.8A1.8,1.8,0,0,0,22,14H18.6a2.4,2.4,0,0,0-2.2-1.5H14l-1.5,1.9L11,12.5H8.5A2.4,2.4,0,0,0,6.4,14H3a1.8,1.8,0,0,0-1.8,1.8v4.7H6.3v1.7H18.7V20.5Zm-1.5-4.7V19H18.7V15.5H22A.3.3,0,0,1,22.3,15.8ZM2.7,19V15.8a.3.3,0,0,1,.3-.3H6.3V19Zm14.5,1.7H7.8V14.8a.7.7,0,0,1,.7-.8h1.8l2.2,2.8L14.7,14h1.7a.7.7,0,0,1,.8.8Z"></path>
            <path d="M20,12.5a2.8,2.8,0,0,0,2.8-2.8,2.8,2.8,0,0,0-5.6,0A2.8,2.8,0,0,0,20,12.5Zm0-4.1a1.3,1.3,0,1,1-1.3,1.3A1.3,1.3,0,0,1,20,8.4Z"></path>
          </g>
        </g>
      </g>
    </IconBase>);
};

Team.defaultProps = {
  title: 'Team',
};

export default Team;
